import React, { useContext, useEffect, useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";

const apiUrl = process.env.REACT_APP_API_URL;

const translations = {
  en: {
    selectLanguage: "Select Language:",
    questionTitle: "How much money have you lost?",
    amountPlaceholder: "Type your amount here...",
    moveError:"Please answer the current question before proceeding to the next one.",
    ok: "OK",
    errorNoAmount: "Please enter the amount before proceeding.",
    errorApi: "Failed to push data to API",
  },
  Hi: {
    selectLanguage: "भाषा चुनें:",
    questionTitle: "आपने कितना पैसा खोया है?",
    amountPlaceholder: "यहाँ अपनी राशि लिखें...",
    ok: "ठीक है",
    errorNoAmount: "कृपया आगे बढ़ने से पहले राशि दर्ज करें।",
    errorApi: "डेटा API में भेजने में विफल",
    moveError:"कृपया अगले प्रश्न पर जाने से पहले वर्तमान प्रश्न का उत्तर दें।",
  },
  Kn: {
    selectLanguage: "ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ:",
    questionTitle: "ನೀವು ಎಷ್ಟು ಹಣವನ್ನು ಕಳೆದುಕೊಂಡಿದ್ದೀರಿ?",
    amountPlaceholder: "ನಿಮ್ಮ ಮೊತ್ತವನ್ನು ಇಲ್ಲಿ ನಮೂದಿಸಿ...",
    ok: "ಸರಿ",
    errorNoAmount: "ದಯವಿಟ್ಟು ಮುಂದುವರೆಯುವ ಮೊದಲು ಮೊತ್ತ ನಮೂದಿಸಿ.",
    errorApi: "ಎಪಿಐಗೆ ಡೇಟಾವನ್ನು ತಳ್ಳಲು ವಿಫಲವಾಗಿದೆ",
    moveError:"ದಯವಿಟ್ಟು ಮುಂದಿನ ಪ್ರಶ್ನೆಗೆ ಹೋಗುವ ಮೊದಲು ಪ್ರಸ್ತುತ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರ ನೀಡಿ.",
  },

};

const HowMuch = ({ onNext, onHowMuchSelected, onQuestion, answer, apiKey, botToken, vist_id, app_ver,selectedLang }) => {
  const [showOkButton, setShowOkButton] = useState(true);
  const [error, setError] = useState(null);
  const [howMuch, setHowMuch] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  const audioMap = {
    en: "audio/English BOT Audios/howmuch.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio4.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio4.m4a",
    tcy: "audio/cybervictim_tcy.mp3",
  };

    useEffect(() => {
      if (audioRef.current) {
        // Update the audio source and reload the element
        audioRef.current.src = audioMap[selectedLang] || audioMap["en"];
        audioRef.current.load();
        // If audio was playing, continue playing the new audio
        if (isPlaying) {
          audioRef.current.play();
        }
      }
    }, [selectedLang, isPlaying]);

     useEffect(() => {
         const handler = () => {
          if (audioRef.current) {
             audioRef.current.pause();
             audioRef.current.currentTime = 0;
              setIsPlaying(false);
            }
          };
          window.addEventListener('pauseAllAudio', handler);
          return () => window.removeEventListener('pauseAllAudio', handler);
        }, []);
  // Fetch the previously saved amount from localStorage, if available
  useEffect(() => {
    const storedData = localStorage.getItem("howMuch");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setHowMuch(parsed);
      onHowMuchSelected(parsed); // Pre-fill the input with stored value
    }
  }, []);

  // Helper function to format numbers in Indian style with commas
  const formatNumberWithCommas = (number) => {
    const [integerPart, decimalPart] = number.split(".");
    let lastThreeDigits = integerPart.slice(-3);
    let restDigits = integerPart.slice(0, -3);
    if (restDigits !== "") {
      restDigits = restDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
      lastThreeDigits = restDigits + "," + lastThreeDigits;
    }
    return decimalPart !== undefined ? lastThreeDigits + "." + decimalPart.slice(0, 2) : lastThreeDigits;
  };

  // Remove commas before parsing back to the original number string
  const removeCommas = (numberString) => {
    return numberString.replace(/,/g, "");
  };

  // Handle changes in the amount input field and format the value with commas and dots
  const handleChange = (event) => {
    event.preventDefault();
    const inputValue = event.target.value;
    if (/^\d*\.?\d*$/.test(removeCommas(inputValue))) {
      const formattedValue = formatNumberWithCommas(removeCommas(inputValue));
      setHowMuch(formattedValue);
      onHowMuchSelected(removeCommas(formattedValue)); // Pass the input value without commas to the parent component
      setShowOkButton(true);
      setError("");
    }
  };
  // Handle the OK button click event and submit the amount to the backend API
  const handleOkClick = async (e) => {
    e.preventDefault();
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    if (howMuch) {
      try {
        const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_text`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            api_key: apiKey,
            visitor_token: vist_id,
            qtion_id: "66f652b6e0c73",
            qtion_num: "2",
            option_val: removeCommas(howMuch),
            lac_token: botToken,
            app_ver: app_ver,
            bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
          }),
        });
        if (!response.ok) {
          throw new Error(translations[selectedLang].errorApi);
        }
        const data = await response.json();
        if (data.resp.error_code === "0") {
          setError("");
          onNext(3, howMuch);
          onQuestion(4);
          localStorage.setItem("howMuch", JSON.stringify(howMuch));
        } else {
          setError("errorApi");
        }
      } catch (error) {
        console.error("Error saving data:", error);
        setError("errorApi");
      }
    } else {
      setError("errorNoAmount");
      setShowOkButton(false);
    }
  };

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };
  return (
    <div className="question">
      <div>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <div style={{ display: "flex" }}>
            <h2>
              {translations[selectedLang].questionTitle}
              <span style={{ color: "red" }}>*</span>
            </h2>
            <button onClick={toggleAudio} className="audio-button">
              {isPlaying ? <FaPause color="White" size={12} style={{ marginBottom: '25px' }} /> : <FaPlay color="White" size={12} style={{ marginBottom: '25px' }}/>}
            </button>
          </div>
          <audio ref={audioRef} onEnded={handleAudioEnd}>
            <source src={audioMap[selectedLang]} type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
          <div className="options-container">
            <div style={{ display: "flex", alignItems: "center" }}>
              <span className="rupee-symbol">₹</span>
              <input
                className="text-money-input"
                value={howMuch}
                onChange={handleChange}
                placeholder={translations[selectedLang].amountPlaceholder}
                id="lose-money"
                type="text"
                min="1"
                autoComplete="off"
                inputMode="numeric"
              />
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", zIndex: "9" }}>
            {showOkButton && (
              <button type="button" className="ok-btn" onClick={handleOkClick}>
                {translations[selectedLang].ok}
              </button>
            )}
          </div>
          {error && (
            <div className="error-message" style={{ position: "relative", zIndex: "1000" }}>
              {translations[selectedLang][error]}
            </div>
          )}
          {answer[2] && (
            <p className="alert-box">
              {translations[selectedLang].moveError}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default HowMuch;
